import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-slate-950 p-8">
          <div className="max-w-md rounded-xl border border-rose-300/30 bg-rose-500/10 p-6 text-center">
            <h2 className="mb-2 text-lg font-semibold text-rose-100">Algo salió mal</h2>
            <p className="mb-4 text-sm text-slate-300">
              Ocurrió un error inesperado. Recargá la página e intentá de nuevo.
            </p>
            <pre className="mb-4 max-h-32 overflow-auto rounded bg-black/30 p-2 text-left text-[11px] text-rose-200">
              {this.state.error?.message}
            </pre>
            <button
              onClick={() => window.location.reload()}
              className="rounded-lg bg-rose-600 px-4 py-2 text-sm font-semibold text-white hover:bg-rose-500"
            >
              Recargar
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
